<script setup>
import { ref } from 'vue'
import { useSeoMeta, useHead } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'
import { useProjectStore } from '@stores/project'
import { useServiceStore } from '@stores/service'
import LoadingOverlay from '@components/global/LoadingOverlay.vue'
import Hero from '@sections/work/Hero.vue'
import Projects from '@sections/work/Projects.vue'
import Services from '@sections/global/Services.vue'
import Testimonials from '@sections/global/Testimonials.vue'

const global = useGlobalStore()
const projectStore = useProjectStore()
const serviceStore = useServiceStore()
const riveReady = ref(false)

useSeoMeta({
	title: () => global.pages.find((page) => page.path === 'work')?.title ?? global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === 'work')?.description ?? global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === 'work')?.image ?? global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<main>
		<LoadingOverlay v-if="!riveReady || !projectStore.ready || !serviceStore.ready || !global.testimonials.length" />
		<Hero @rive-loaded="riveReady = true" />
		<Projects />
		<Services />
		<Testimonials />
	</main>
</template>
